module.exports = __webpack_public_path__ + "4da97919913ac22389412db5fc814f65.svg";